import * as z from "zod";

/** Whether Commerce Agent can send a subscribed SMS from the number that send will use. */
export const getRecoverSmsSenderReady = {
  name: "getRecoverSmsSenderReady" as const,
  input: z.object({}),
  output: z.object({ ready: z.boolean() }),
};
